module.exports = __webpack_public_path__ + "static/media/Sybill Trelawney 2.e55ee06f.jpg";